export const SET_SHAREHOLDER = "SET_SHAREHOLDER";
export const SET_SHAREHOLDERS = "SET_SHAREHOLDERS";
